export const validate = (obj) => {
   console.log("🚀 ~ file: validate.js:2 ~ validate ~ obj:", obj)

   return Object.keys(obj).reduce((acc, curr) =>
      obj[curr] ?
         acc :
         [...acc, curr],
      [])
}